import React from 'react';

import { FormElement, Label } from '@dashboard/components/Form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@dashboard/components/ui/select';

const ZERO_AMOUNT_OPTIONS = [
  { value: 'include', label: 'Include' },
  { value: 'exclude', label: 'Exclude' },
  { value: 'only', label: 'Only' },
];

// `true` is the checkbox's old `?zeroAmount=true`, kept so saved links still open on "Only".
export const parseZeroAmount = value => {
  if (value === true) return 'only';
  return ZERO_AMOUNT_OPTIONS.some(option => option.value === value) ? value : 'include';
};

// `$ne` rather than `$gt` so Exclude and Only always add up to Include.
export const getZeroAmountFilter = zeroAmount => {
  if (zeroAmount === 'only') return { amount: 0 };
  if (zeroAmount === 'exclude') return { amount: JSON.stringify({ $ne: 0 }) };
  return {};
};

const AdminZeroAmountFilter = ({ value, onChange }) => (
  <FormElement className="!mb-0">
    <Label htmlFor="zeroAmount">$0 amounts</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id="zeroAmount" className="w-28">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {ZERO_AMOUNT_OPTIONS.map(option => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </FormElement>
);

export default AdminZeroAmountFilter;
